import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  Label,
  LabelGroup,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  BriefcaseIcon,
  CheckCircleIcon
} from "@patternfly/react-icons";


const EducationDirectionCareers = ({
  careers = {}
}) => {
  const {
    introduction,
    workplaces = [],
    positions = []
  } = careers;

  if (
    !introduction &&
    !workplaces.length &&
    !positions.length
  ) {
    return null;
  }

  return (
    <PageSection
      id="careers"
      className="education-direction-section"
      isWidthLimited
      aria-labelledby="education-direction-careers-title"
    >
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content
                style={{
                  textAlign: "center"
                }}
              >
                <h2 id="education-direction-careers-title">
                  Gdzie możesz pracować?
                </h2>

                {introduction && (
                  <p>{introduction}</p>
                )}
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid hasGutter>
            {workplaces.length > 0 && (
            <GridItem
                span={12}
                lg={6}
            >
                <Card
                isGlass
                isFullHeight
                >
                <CardBody>
                    <Stack hasGutter>
                    <StackItem>
                        <Content>
                        <h3>Możliwe miejsca pracy</h3>
                        </Content>
                    </StackItem>

                    <StackItem>
                        <List isPlain>
                        {workplaces.map((workplace) => (
                            <ListItem
                            key={workplace}
                            icon={<CheckCircleIcon />}
                            >
                            {workplace}
                            </ListItem>
                        ))}
                        </List>
                    </StackItem>
                    </Stack>
                </CardBody>
                </Card>
            </GridItem>
            )}

            {positions.length > 0 && (
              <GridItem
                span={12}
                lg={6}
              >
                <Card
                  isGlass
                  isFullHeight
                >
                  <CardBody>
                    <Stack hasGutter>
                      <StackItem>
                        <Content>
                          <h3>
                            {/* <BriefcaseIcon />{" "} */}
                            Przykładowe stanowiska
                          </h3>
                          <p>
                            Konkretne stanowisko zależy
                            od zdobytych umiejętności,
                            doświadczenia i dalszego rozwoju.
                          </p>
                        </Content>
                      </StackItem>

                      <StackItem>
                        <LabelGroup 
                          collapsedText='${remaining} więcej'
                          expandedText='Pokaż mniej'
                          defaultIsOpen={true}
                        >
                          {positions.map((position) => (
                            <Label
                              key={position}
                              color="blue"
                              variant="outline"
                            >
                              {position}
                            </Label>
                          ))}
                        </LabelGroup>
                      </StackItem>
                    </Stack>
                  </CardBody>
                </Card>
              </GridItem>
            )}
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default EducationDirectionCareers;